module.exports = __webpack_public_path__ + "static/img/cert-06.ee986ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert/cert-06.png
// module id = B2zO
// module chunks = 1